import REMAINING_STICKS_VALUES from '../../consts/device/remainingSticksValues';
import deviceTypes from '../../enums/device/deviceTypes';
import helpers from '../../utils/helpers';
import fwuService from '../device/fwuService';
import deviceGlobalConfigService from './iotDeviceGlobalConfigService';

let vibrationAlarmTimeout;

const setVibrationAlarmTimeout = (deviceAlarmDuration, callback) => {
    vibrationAlarmTimeout = setTimeout(() => helpers.runFunction(callback), deviceAlarmDuration);
};

const clearVibrationAlarmTimeout = () => clearTimeout(vibrationAlarmTimeout);

const isSettingAvailable = (
    iotDevice,
    isGlobalSupported,
    isSupported,
    isNeedHolderCheck = true,
    isFwuCanHelp = true
) => {
    if (isSupported && isGlobalSupported) return true;

    if (!isGlobalSupported) return false;

    const {device, holder} = iotDevice || {};

    if (!device) return false;
    const isGlobalHolderCheck = deviceGlobalConfigService.isGlobalHolderCheck(iotDevice);

    if (isNeedHolderCheck && isGlobalHolderCheck) {
        if (!device?.isHolderConnected || !holder?.type) {
            return true;
        }
    }

    if (!isFwuCanHelp) return false;

    const isFWUAvailable = fwuService.isFWUAvailable(device.type);

    return isFWUAvailable;
};

const isHolderConnectedAndInSBLMode = ({device, holder}) => device?.isHolderConnected && isHolderInSBLMode({holder});

const isHolderInSBLMode = ({holder}) => {
    return holder?.is_device_in_sbl_mode;
};

const isHolderEngineAvailable = ({holder_engine}) => !!holder_engine;

const isHolderEngineInSBLMode = ({holder_engine}) => holder_engine?.is_device_in_sbl_mode;

const isDeviceLocked = (iotDevice) =>
    iotDevice?.holder?.parent_protection_mode || iotDevice?.device?.parent_protection_mode;

const getEnergy = ({constants, batteryCharge, batteryVoltage, batteryVoltageFactor}) => {
    const {
        capacityConstant,
        voltageThreshold,
        voltageCoefficient,
        levelThreshold,
        levelCoefficient,
        correctionCoefficient,
    } = constants;

    const vBattery = (batteryVoltageFactor + 1) * Math.pow(2, -16);
    const v = vBattery * batteryVoltage * 32;

    return (
        capacityConstant +
        (v - voltageThreshold) * voltageCoefficient +
        ((batteryCharge - levelThreshold) * levelCoefficient + batteryCharge * correctionCoefficient)
    );
};

const getNewFormulaEnergy = ({constants, batteryCharge, batteryVoltage, batteryVoltageFactor}) => {
    const {capacityConstant, voltageCoefficient, levelCoefficient} = constants;

    const vBattery = (batteryVoltageFactor + 1) * Math.pow(2, -16);
    const v = vBattery * batteryVoltage;

    return v * voltageCoefficient + batteryCharge * levelCoefficient + capacityConstant;
};

const getRemainingSticks = (iotDevice) => {
    const {battery_charge, batteryVoltage, batteryVoltageFactor, type} = iotDevice?.device || {};

    if (!battery_charge || !batteryVoltage || !batteryVoltageFactor) return null;

    const values = REMAINING_STICKS_VALUES[type];

    if (!values) return null;

    const isNewFormula = type === deviceTypes.DEV_TYPE_P1V41J_CONTROL || type === deviceTypes.DEV_TYPE_P1V41A_CONTROL;
    const {energyConstant, maxRemainingSticks} = values;
    const props = {constants: values, batteryCharge: battery_charge, batteryVoltage, batteryVoltageFactor};
    const energy = isNewFormula ? getNewFormulaEnergy(props) : getEnergy(props);

    const result = Math.floor(energy / energyConstant);

    if (result < 0) return 0;

    if (result > maxRemainingSticks) {
        return maxRemainingSticks + '+';
    }

    return result;
};

export default {
    clearVibrationAlarmTimeout,
    isDeviceLocked,
    isHolderConnectedAndInSBLMode,
    isHolderEngineAvailable,
    isHolderEngineInSBLMode,
    isHolderInSBLMode,
    isSettingAvailable,
    setVibrationAlarmTimeout,
    getRemainingSticks,
};
